try {
	document.querySelector(':focus-visible');
} catch (t) {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	let t = [
			'ARROWUP',
			'ARROWDOWN',
			'ARROWLEFT',
			'ARROWRIGHT',
			'TAB',
			'ENTER',
			'SPACE',
			'ESCAPE',
			'HOME',
			'END',
			'PAGEUP',
			'PAGEDOWN',
		],
		e = null,
		i = null;
	window.addEventListener('keydown', (e) => {
		t.includes(e.code.toUpperCase()) && (i = !1);
	}),
		window.addEventListener('mousedown', (t) => {
			i = !0;
		}),
		window.addEventListener(
			'focus',
			() => {
				e && e.classList.remove('focused'), i || (e = document.activeElement).classList.add('focused');
			},
			!0
		);
}

/*************************************************************
 * ProductRecommendations
 ***********************************************************/
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		let t = (t, e) => {
			t[0].isIntersecting &&
				(e.unobserve(this),
				fetch(this.dataset.url)
					.then((t) => t.text())
					.then((t) => {
						let e = document.createElement('div');
						e.innerHTML = t;
						let i = e.querySelector('product-recommendations');
						i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML),
							!this.querySelector('slideshow-component') &&
								this.classList.contains('complementary-products') &&
								this.remove(),
							e.querySelector('.grid__item') && this.classList.add('product-recommendations--loaded');
					})
					.catch((t) => {
						console.error(t);
					}));
		};
		new IntersectionObserver(t.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
	}
}

customElements.define('product-recommendations', ProductRecommendations);

/*************************************************************
 * MenuDrawer
 ***********************************************************/
class MenuDrawer extends HTMLElement {
	constructor() {
		super(),
			(this.mainDetailsToggle = this.querySelector('details')),
			this.addEventListener('keyup', this.onKeyUp.bind(this)),
			this.addEventListener('focusout', this.onFocusOut.bind(this));

		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((t) => t.addEventListener('click', this.onSummaryClick.bind(this))),
			this.querySelectorAll('button:not(.menu-drawer__close-menu-btn)').forEach((t) =>
				t.addEventListener('click', this.onCloseButtonClick.bind(this))
			);
	}

	onKeyUp(t) {
		if ('ESCAPE' !== t.code.toUpperCase()) return;
		let e = t.target.closest('details[open]');
		e &&
			(e === this.mainDetailsToggle
				? this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector('summary'))
				: this.closeSubmenu(e));
	}

	onSummaryClick(t) {
		let e = t.currentTarget,
			i = e.parentNode,
			s = i.closest('.has-submenu'),
			n = i.hasAttribute('open'),
			o = window.matchMedia('(prefers-reduced-motion: reduce)');
		function r() {
			trapFocus(e.nextElementSibling, i.querySelector('button')),
				e.nextElementSibling.removeEventListener('transitionend', r);
		}
		i === this.mainDetailsToggle
			? (n && t.preventDefault(),
			  n ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e),
			  window.matchMedia('(max-width: 990px)') &&
					document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`))
			: setTimeout(() => {
					i.classList.add('menu-opening'),
						e.setAttribute('aria-expanded', !0),
						s && s.classList.add('submenu-open'),
						!o || o.matches ? r() : e.nextElementSibling.addEventListener('transitionend', r);
			  }, 100);
	}

	openMenuDrawer(t) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening');
		}),
			t.setAttribute('aria-expanded', !0),
			trapFocus(this.mainDetailsToggle, t),
			document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(t, e = !1) {
		void 0 !== t &&
			(this.mainDetailsToggle.classList.remove('menu-opening'),
			this.mainDetailsToggle.querySelectorAll('details').forEach((t) => {
				t.removeAttribute('open'), t.classList.remove('menu-opening');
			}),
			this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((t) => {
				t.classList.remove('submenu-open');
			}),
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
			removeTrapFocus(e),
			this.closeAnimation(this.mainDetailsToggle));
	}

	onFocusOut(t) {
		setTimeout(() => {
			this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement) &&
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(t) {
		let e = t.currentTarget.closest('details');
		this.closeSubmenu(e);
	}

	closeSubmenu(t) {
		let e = t.closest('.submenu-open');
		e && e.classList.remove('submenu-open'),
			t.classList.remove('menu-opening'),
			t.querySelector('summary').setAttribute('aria-expanded', !1),
			removeTrapFocus(t.querySelector('summary')),
			this.closeAnimation(t);
	}

	closeAnimation(t) {
		let e,
			i = (s) => {
				void 0 === e && (e = s);
				let n = s - e;
				n < 400
					? window.requestAnimationFrame(i)
					: (t.removeAttribute('open'),
					  t.closest('details[open]') && trapFocus(t.closest('details[open]'), t.querySelector('summary')));
			};
		window.requestAnimationFrame(i);
	}
}
customElements.define('menu-drawer', MenuDrawer);

/*************************************************************
 * HeaderDrawer
 ***********************************************************/
class HeaderDrawer extends MenuDrawer {
	constructor() {
		super(),
			this.querySelectorAll('.menu-drawer__close-menu-btn').forEach((t) =>
				t.addEventListener('click', this.closeButtonClick.bind(this))
			);
	}
	openMenuDrawer(t) {
		(this.header = this.header || document.querySelector('.section-header')),
			(this.borderOffset =
				this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
					? 1
					: 0),
			document.documentElement.style.setProperty(
				'--header-bottom-position',
				`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
			),
			this.header.classList.add('menu-open'),
			setTimeout(() => {
				this.mainDetailsToggle.classList.add('menu-opening');
			}),
			t.setAttribute('aria-expanded', !0),
			trapFocus(this.mainDetailsToggle, t),
			document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
	closeMenuDrawer(t, e) {
		super.closeMenuDrawer(t, e), this.header.classList.remove('menu-open');
	}
	closeButtonClick(t) {
		this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector('summary')),
			this.querySelector('.header__icon--menu[aria-expanded=true]').setAttribute('aria-expanded', 'false');
	}
}
customElements.define('header-drawer', HeaderDrawer);

/*************************************************************
 * ProductsMegaMenu
 ***********************************************************/
class ProductsMegaMenu extends HTMLElement {
	constructor() {
		super(),
			(this.details = this.querySelector('details[id^="ProductsMegaMenu-"]')),
			(this.mainLink = this.querySelector('summary.header__menu-item')),
			(this.body = this.querySelector('.products-mega-menu__body')),
			(this.overlay = this.querySelector('.products-mega-menu__overlay')),
			(this.items = this.querySelectorAll('[id^="ProductsMegaMenu-Item"]')),
			(this.links = this.querySelectorAll('[id^="ProductsMegaMenu-Link"]')),
			this.mainLink.addEventListener('mouseover', this.openMenu.bind(this)),
			this.overlay.addEventListener('mouseover', this.closeMenu.bind(this)),
			this.overlay.addEventListener('click', this.closeMenu.bind(this)),
			document.addEventListener('click', this.outsideClick.bind(this)),
			this.links.forEach((t) => {
				t.addEventListener('mouseover', this.displayContent.bind(this));
			});
	}
	displayContent(t) {
		this.items.forEach((t) => {
			t.classList.remove('products-mega-menu__item--active');
		}),
			t.target.closest('[id^="ProductsMegaMenu-Item"]').classList.add('products-mega-menu__item--active');
	}
	openMenu() {
		this.details.setAttribute('open', ''),
			document.querySelectorAll('[id^="Details-HeaderMenu"]').forEach((t) => {
				t.removeAttribute('open');
			});
	}
	closeMenu() {
		this.details.removeAttribute('open');
	}
	outsideClick(t) {
		this.details.hasAttribute('open') && t.target != this.body && (this.body.contains(t.target) || this.closeMenu());
	}
}
customElements.define('products-mega-menu', ProductsMegaMenu);

/*************************************************************
 * ModalDialog
 ***********************************************************/
class ModalDialog extends HTMLElement {
	constructor() {
		super(),
			this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, !1)),
			this.addEventListener('keyup', (t) => {
				'ESCAPE' === t.code.toUpperCase() && this.hide();
			}),
			this.classList.contains('media-modal')
				? this.addEventListener('pointerup', (t) => {
						'mouse' !== t.pointerType || t.target.closest('deferred-media, product-model') || this.hide();
				  })
				: this.addEventListener('click', (t) => {
						t.target === this && this.hide();
				  });
	}
	connectedCallback() {
		this.moved || ((this.moved = !0), document.body.appendChild(this));
	}
	show(t) {
		this.openedBy = t;
		let e = this.querySelector('.template-popup');
		document.body.classList.add('overflow-hidden'),
			this.setAttribute('open', ''),
			e && e.loadContent(),
			trapFocus(this, this.querySelector('[role="dialog"]')),
			window.pauseAllMedia();
	}
	hide() {
		document.body.classList.remove('overflow-hidden'),
			document.body.dispatchEvent(new CustomEvent('modalClosed')),
			this.removeAttribute('open'),
			removeTrapFocus(this.openedBy),
			window.pauseAllMedia();
	}
}

customElements.define('modal-dialog', ModalDialog);

/*************************************************************
 * ModalOpener
 ***********************************************************/
class ModalOpener extends HTMLElement {
	constructor() {
		super();
		let t = this.querySelector('button');
		if (!t) return;
		t.addEventListener('click', () => {
			let e = document.querySelector(this.getAttribute('data-modal'));
			e && e.show(t);
		});
	}
}

customElements.define('modal-opener', ModalOpener);

/*************************************************************
 * ModalV2
 ***********************************************************/
class ModalV2 extends HTMLElement {
	constructor() {
		super(),
			(this.openBtns = this.querySelectorAll('.modal-v2__open-btn')),
			(this.closeBtns = this.querySelectorAll('.modal-v2__close-btn')),
			this.openBtns.forEach((t) => {
				t.addEventListener('click', this.openModal.bind(this));
			}),
			this.closeBtns.forEach((t) => {
				t.addEventListener('click', this.closeModal.bind(this));
			});
	}
	openModal() {
		(this.dataset.open = 'true'), document.body.classList.add('overflow-hidden');
	}
	closeModal() {
		(this.dataset.open = 'false'), document.body.classList.remove('overflow-hidden');
	}
}

customElements.define('modal-v2', ModalV2);

/*************************************************************
 * DeferredMedia
 ***********************************************************/
class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		let t = this.querySelector('[id^="Deferred-Poster-"]');
		if (!t) return;
		t.addEventListener('click', this.loadContent.bind(this));
	}

	loadContent(t = !0) {
		if ((window.pauseAllMedia(), !this.getAttribute('loaded'))) {
			let e = document.createElement('div');
			e.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(!0)),
				this.setAttribute('loaded', !0);
			let i = this.appendChild(e.querySelector('video, model-viewer, iframe'));
			t && i.focus();
		}
	}
}

customElements.define('deferred-media', DeferredMedia);

/*************************************************************
 * CopyButton
 ***********************************************************/
class CopyButton extends HTMLElement {
	constructor() {
		super(),
			(this.textarea = document.createElement('textarea')),
			this.textarea.classList.add('visually-hidden'),
			(this.textarea.value = this.dataset.content.trim()),
			this.appendChild(this.textarea),
			this.addEventListener('click', this.handleClick.bind(this));
	}
	handleClick(t) {
		this.textarea.select(),
			document.execCommand('copy'),
			(this.dataset.success = 'true'),
			setTimeout(() => (this.dataset.success = 'false'), 3e3);
	}
}

customElements.define('copy-button', CopyButton);

/*************************************************************
 * CountdownTimer
 ***********************************************************/
class CountdownTimer extends HTMLElement {
	constructor() {
		super(),
			(this.duration = parseInt(this.dataset.duration)),
			this.initTimer(),
			this.updateTimer(),
			'true' === this.dataset.autoPlay && this.playTimer();
	}
	initTimer() {
		(this.innerHTML = ''), (this.minutesSpan = document.createElement('span'));
		let t = document.createTextNode(':');
		(this.secondsSpan = document.createElement('span')), this.append(this.minutesSpan, t, this.secondsSpan);
	}
	updateTimer() {
		let t = parseInt(this.dataset.duration);
		0 === t && (t = 90);
		let e = Math.floor(t / 60),
			i = t % 60;
		(this.minutesSpan.innerHTML = this.formatNumber(e)),
			(this.secondsSpan.innerHTML = this.formatNumber(i)),
			(this.dataset.duration = t - 1);
	}
	playTimer() {
		this.isPlaying ||
			((this.isPlaying = !0),
			(this.playInterval = setInterval(() => {
				this.updateTimer();
			}, 1e3)));
	}
	pauseTimer() {
		clearTimeout(this.playInterval), (this.isPlaying = !0);
	}
	formatNumber(t) {
		return 1 === t.toString().length ? '0' + t : t;
	}
}

customElements.define('countdown-timer', CountdownTimer);

/*************************************************************
 * SliderComponent
 ***********************************************************/
class SliderComponent extends HTMLElement {
	constructor() {
		if (
			(super(),
			(this.slider = this.querySelector('[id^="Slider-"]')),
			(this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
			(this.enableSliderLooping = !1),
			(this.currentPageElement = this.querySelector('.slider-counter--current')),
			(this.pageTotalElement = this.querySelector('.slider-counter--total')),
			(this.prevButton = this.querySelector('button[name="previous"]')),
			(this.nextButton = this.querySelector('button[name="next"]')),
			!this.slider || !this.nextButton)
		)
			return;

		this.initPages();
		let t = new ResizeObserver((t) => this.initPages());

		if (
			(t.observe(this.slider),
			this.slider.addEventListener('scroll', this.update.bind(this)),
			this.prevButton.addEventListener('click', this.onButtonClick.bind(this)),
			this.nextButton.addEventListener('click', this.onButtonClick.bind(this)),
			(this.sliderControlWrapper = this.querySelector('.slider-buttons')),
			!this.sliderControlWrapper || !this.sliderControlWrapper.querySelector('.slider-counter__link'))
		)
			return;

		(this.sliderFirstItemNode = this.slider.querySelector('.slider__slide')),
			(this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'))),
			this.sliderControlLinksArray.forEach((t) => t.addEventListener('click', this.linkToSlide.bind(this)));
	}
	initPages() {
		(this.sliderItemsToShow = Array.from(this.sliderItems).filter((t) => t.clientWidth > 0)),
			this.sliderItemsToShow.length < 2 ||
				((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
				(this.slidesPerPage = Math.floor(
					(this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
				)),
				(this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
				this.update());
	}

	resetPages() {
		(this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages();
	}

	update() {
		if (!this.slider || !this.nextButton) return;
		let t = this.currentPage;
		if (
			((this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
			this.currentPageElement &&
				this.pageTotalElement &&
				((this.currentPageElement.textContent = this.currentPage),
				(this.pageTotalElement.textContent = this.totalPages)),
			this.currentPage != t &&
				this.dispatchEvent(
					new CustomEvent('slideChanged', {
						detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] },
					})
				),
			(this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')),
			this.sliderControlButtons.length > 0)
		) {
			this.sliderControlButtons.forEach((t) => {
				t.classList.remove('slider-counter__link--active'), t.removeAttribute('aria-current');
			});
			let e = this.sliderControlButtons[this.currentPage - 1];
			e && (e.classList.add('slider-counter__link--active'), e.setAttribute('aria-current', !0));
		}
		this.enableSliderLooping ||
			(this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft
				? this.prevButton.setAttribute('disabled', 'disabled')
				: this.prevButton.removeAttribute('disabled'),
			this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
				? this.nextButton.setAttribute('disabled', 'disabled')
				: this.nextButton.removeAttribute('disabled'));
	}
	isSlideVisible(t, e = 0) {
		let i = this.slider.clientWidth + this.slider.scrollLeft - e;

		return t.offsetLeft + t.clientWidth <= i && t.offsetLeft >= this.slider.scrollLeft;
	}
	onButtonClick(t) {
		t.preventDefault();
		let e = t.currentTarget.dataset.step || 1;
		(this.slideScrollPosition =
			'next' === t.currentTarget.name
				? this.slider.scrollLeft + e * this.sliderItemOffset
				: this.slider.scrollLeft - e * this.sliderItemOffset),
			this.slider.scrollTo({ left: this.slideScrollPosition });
	}
	linkToSlide(t) {
		t.preventDefault();
		let e =
			this.slider.scrollLeft +
			this.sliderFirstItemNode.clientWidth *
				(this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
		this.slider.scrollTo({ left: e });
	}
}

customElements.define('slider-component', SliderComponent);

/*************************************************************
 * SlideshowComponent
 ***********************************************************/
class SlideshowComponent extends SliderComponent {
	constructor() {
		if (
			(super(),
			(this.sliderControlWrapper = this.querySelector('.slider-buttons')),
			(this.enableSliderLooping = !0),
			!this.sliderControlWrapper)
		)
			return;

		(this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')),
			this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
			(this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'))),
			this.sliderControlLinksArray.forEach((t) => t.addEventListener('click', this.linkToSlide.bind(this))),
			this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this)),
			this.setSlideVisibility(),
			'true' === this.slider.getAttribute('data-autoplay') && this.setAutoPlay();
	}

	setAutoPlay() {
		(this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')),
			(this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
			this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this)),
			this.addEventListener('mouseover', this.focusInHandling.bind(this)),
			this.addEventListener('mouseleave', this.focusOutHandling.bind(this)),
			this.addEventListener('focusin', this.focusInHandling.bind(this)),
			this.addEventListener('focusout', this.focusOutHandling.bind(this)),
			this.play(),
			(this.autoplayButtonIsSetToPlay = !0);
	}

	onButtonClick(t) {
		super.onButtonClick(t);
		let e = 1 === this.currentPage,
			i = this.currentPage === this.sliderItemsToShow.length;
		(e || i) &&
			(e && 'previous' === t.currentTarget.name
				? (this.slideScrollPosition =
						this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
				: i && 'next' === t.currentTarget.name && (this.slideScrollPosition = 0),
			this.slider.scrollTo({ left: this.slideScrollPosition }));
	}

	update() {
		super.update(),
			(this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')),
			this.prevButton.removeAttribute('disabled'),
			this.sliderControlButtons.length &&
				(this.sliderControlButtons.forEach((t) => {
					t.classList.remove('slider-counter__link--active'), t.removeAttribute('aria-current');
				}),
				this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active'),
				this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', !0));
	}
	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
			this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
			(this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
	}
	focusOutHandling(t) {
		let e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
		this.autoplayButtonIsSetToPlay && !e && this.play();
	}
	focusInHandling(t) {
		let e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
		e && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause();
	}
	play() {
		this.slider.setAttribute('aria-live', 'off'),
			clearInterval(this.autoplay),
			(this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed));
	}
	pause() {
		this.slider.setAttribute('aria-live', 'polite'), clearInterval(this.autoplay);
	}
	togglePlayButtonState(t) {
		t
			? (this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused'),
			  this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow))
			: (this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused'),
			  this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow));
	}
	autoRotateSlides() {
		let t =
			this.currentPage === this.sliderItems.length
				? 0
				: this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
		this.slider.scrollTo({ left: t });
	}
	setSlideVisibility() {
		this.sliderItemsToShow.forEach((t, e) => {
			let i = t.querySelectorAll('a');
			e === this.currentPage - 1
				? (i.length &&
						i.forEach((t) => {
							t.removeAttribute('tabindex');
						}),
				  t.setAttribute('aria-hidden', 'false'),
				  t.removeAttribute('tabindex'))
				: (i.length &&
						i.forEach((t) => {
							t.setAttribute('tabindex', '-1');
						}),
				  t.setAttribute('aria-hidden', 'true'),
				  t.setAttribute('tabindex', '-1'));
		});
	}
	linkToSlide(t) {
		t.preventDefault();
		let e =
			this.slider.scrollLeft +
			this.sliderFirstItemNode.clientWidth *
				(this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
		this.slider.scrollTo({ left: e });
	}
}

customElements.define('slideshow-component', SlideshowComponent);

/*************************************************************
 * SlideshowComponent
 ***********************************************************/
class SplideComponent extends HTMLElement {
	constructor() {
		super(),
			(this.sliderContainer = this.querySelector('.splide')),
			document.addEventListener('shopify:section:load', (t) => {
				this.initSlider();
			});
	}
	connectedCallback() {
		this.initSlider();
	}
	initSlider() {
		(this.type = this.dataset.type || 'slide'),
			(this.typeMobile = this.dataset.typeMobile || this.type),
			(this.direction = this.dataset.direction || 'ltr'),
			(this.rewind = 'fade' === this.type),
			(this.autoplay = 'true' === this.dataset.autoplay),
			(this.autoplaySpeed =
				this.dataset.autoplaySpeed && !isNaN(parseInt(this.dataset.autoplaySpeed))
					? 1e3 * parseInt(this.dataset.autoplaySpeed)
					: 5e3),
			(this.drag = 'false' !== this.dataset.drag && ('free' !== this.dataset.drag || 'free')),
			(this.focus = this.dataset.focus || 0),
			(this.trimSpace = 'false' !== this.dataset.trimSpace),
			(this.arrows = 'false' !== this.dataset.arrows),
			(this.arrowsColor = this.dataset.arrowsColor ? ` color-${this.dataset.arrowsColor}` : ''),
			(this.pagination = 'false' !== this.dataset.pagination),
			(this.omitEnd = 'false' !== this.dataset.omitEnd),
			(this.dotsColor = this.dataset.dotsColor ? ` color-${this.dataset.dotsColor} dots-custom-color` : ''),
			(this.slidesDesktop =
				this.dataset.slidesDesktop && !isNaN(parseInt(this.dataset.slidesDesktop))
					? parseInt(this.dataset.slidesDesktop)
					: 3),
			(this.autoWidth = 'true' === this.dataset.autoWidth),
			(this.slidesMobile =
				this.dataset.slidesMobile && !isNaN(parseInt(this.dataset.slidesMobile))
					? parseInt(this.dataset.slidesMobile)
					: 1),
			(this.perMoveDesktop =
				this.dataset.perMoveDesktop && !isNaN(parseInt(this.dataset.perMoveDesktop))
					? parseInt(this.dataset.perMoveDesktop)
					: 1),
			(this.perMoveMobile =
				this.dataset.perMoveMobile && !isNaN(parseInt(this.dataset.perMoveMobile))
					? parseInt(this.dataset.perMoveMobile)
					: 1),
			(this.gapDesktop = this.dataset.gapDesktop ? parseInt(this.dataset.gapDesktop) : 30),
			(this.gapMobile = this.dataset.gapMobile ? parseInt(this.dataset.gapMobile) : 15),
			(this.paddingCalcDesktop = 'true' === this.dataset.paddingCalcDesktop),
			(this.rightPaddingDesktop = parseInt(this.dataset.sidePaddingDesktop) || 0),
			(this.leftPaddingDesktop = this.dataset.paddingCalcDesktop ? 0 : this.rightPaddingDesktop),
			(this.paddingCalcMobile = 'true' === this.dataset.paddingCalcMobile),
			(this.rightPaddingMobile = parseInt(this.dataset.sidePaddingMobile) || 0),
			(this.leftPaddingMobile = this.paddingCalcMobile ? 0 : this.rightPaddingMobile),
			(this.destroyDesktop = 'true' === this.dataset.destroyDesktop),
			(this.destroyMobile = 'true' === this.dataset.destroyMobile),
			(this.config = {
				type: this.type,
				direction: this.direction,
				rewind: this.rewind,
				autoplay: this.autoplay,
				interval: this.autoplaySpeed,
				drag: this.drag,
				focus: this.focus,
				trimSpace: this.trimSpace,
				arrows: this.arrows,
				pagination: this.pagination,
				omitEnd: this.omitEnd,
				perPage: this.slidesDesktop,
				perMove: this.perMoveDesktop,
				autoWidth: this.autoWidth,
				gap: this.gapDesktop,
				paddingCalc: this.paddingCalcDesktop,
				padding: { left: this.leftPaddingDesktop, right: this.rightPaddingDesktop },
				destroy: this.destroyDesktop,
				classes: { arrow: `splide__arrow${this.arrowsColor}`, page: `splide__pagination__page${this.dotsColor}` },
				easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
				breakpoints: {
					749: {
						type: this.typeMobile,
						perPage: this.slidesMobile,
						perMove: this.perMoveMobile,
						gap: this.gapMobile,
						paddingCalc: this.paddingCalcMobile,
						padding: { left: this.leftPaddingMobile, right: this.rightPaddingMobile },
						destroy: this.destroyMobile,
					},
				},
			});
		let t = new Splide(this.sliderContainer, this.config);
		t.on('mounted', () => {
			let e = t.index,
				i = t.Components.Elements.slides[e];
			if (i) {
				let s = i.querySelector('img');
				s
					? s.complete
						? (i.classList.add('is-instant-active'), this.setActiveSlideHeight(i))
						: s.addEventListener('load', () => {
								i.classList.add('is-instant-active'), this.setActiveSlideHeight(i);
						  })
					: (i.classList.add('is-instant-active'), this.setActiveSlideHeight(i));
			}
			let n = debounce(() => {
				let e = t.Components.Elements.slides[t.index];
				this.setActiveSlideHeight(e);
			}, 200);
			window.addEventListener('resize', n);
		}),
			t.on('move', (e) => {
				let i = t.index,
					s = t.Components.Elements.slides;
				if (s) {
					let n = s[i];
					n &&
						(s.forEach((t) => t.classList.remove('is-instant-active')),
						n.classList.add('is-instant-active'),
						this.setActiveSlideHeight(n));
				}
			}),
			'true' === this.dataset.imageSlider &&
				window.addEventListener('load', () => {
					let e = t.Components.Elements.slides[t.index];
					this.setActiveSlideHeight(e);
				}),
			t.mount();
	}
	setActiveSlideHeight(t) {
		if (t) {
			let e = t.offsetHeight;
			this.style.setProperty('--active-slide-height', `${e}px`);
		}
	}
}

customElements.define('splide-component', SplideComponent);

/*************************************************************
 * DetailsDisclosure
 ***********************************************************/
class DetailsDisclosure extends HTMLElement {
	constructor() {
		super(),
			(this.mainDetailsToggle = this.querySelector('details')),
			(this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling),
			this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this)),
			this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
	}
	onFocusOut() {
		setTimeout(() => {
			this.contains(document.activeElement) || this.close();
		});
	}
	onToggle() {
		this.animations || (this.animations = this.content.getAnimations()),
			this.mainDetailsToggle.hasAttribute('open')
				? this.animations.forEach((t) => t.play())
				: this.animations.forEach((t) => t.cancel());
	}
	close() {
		this.mainDetailsToggle.removeAttribute('open'),
			this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', !1);
	}
}
customElements.define('details-disclosure', DetailsDisclosure);

/*************************************************************
 * DetailsDisclosure
 ***********************************************************/
class HeaderMenu extends DetailsDisclosure {
	constructor() {
		super(), (this.header = document.querySelector('.header-wrapper'));
	}
	onToggle() {
		this.header &&
			((this.header.preventHide = this.mainDetailsToggle.open),
			'' === document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') &&
				document.documentElement.style.setProperty(
					'--header-bottom-position-desktop',
					`${Math.floor(this.header.getBoundingClientRect().bottom)}px`
				));
	}
}

customElements.define('header-menu', HeaderMenu);

class DetailsModal extends HTMLElement {
	constructor() {
		super(),
			(this.detailsContainer = this.querySelector('details')),
			(this.summaryToggle = this.querySelector('summary')),
			this.detailsContainer.addEventListener('keyup', (t) => 'ESCAPE' === t.code.toUpperCase() && this.close()),
			this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this)),
			this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this)),
			this.summaryToggle.setAttribute('role', 'button');
	}
	isOpen() {
		return this.detailsContainer.hasAttribute('open');
	}
	onSummaryClick(t) {
		t.preventDefault(), t.target.closest('details').hasAttribute('open') ? this.close() : this.open(t);
	}
	onBodyClick(t) {
		(!this.contains(t.target) || t.target.classList.contains('modal-overlay')) && this.close(!1);
	}
	open(t) {
		(this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
			t.target.closest('details').setAttribute('open', !0),
			document.body.addEventListener('click', this.onBodyClickEvent),
			document.body.classList.add('overflow-hidden'),
			trapFocus(
				this.detailsContainer.querySelector('[tabindex="-1"]'),
				this.detailsContainer.querySelector('input:not([type="hidden"])')
			);
	}
	close(t = !0) {
		removeTrapFocus(t ? this.summaryToggle : null),
			this.detailsContainer.removeAttribute('open'),
			document.body.removeEventListener('click', this.onBodyClickEvent),
			document.body.classList.remove('overflow-hidden');
	}
}
customElements.define('details-modal', DetailsModal);

/*************************************************************
 * HotspotButton
 ***********************************************************/
/*************************************************************
 * HotspotButton
 ***********************************************************/
let hotspotButtons = [];
function registerHotspotButton(t) {
	hotspotButtons.push(t);
}
function unregisterHotspotButton(t) {
	let e = hotspotButtons.indexOf(t);
	-1 !== e && hotspotButtons.splice(e, 1);
}
document.addEventListener('mousedown', function (t) {
	for (let e of hotspotButtons) 'true' !== e.dataset.open || e.contains(t.target) || e.closeModal();
});

class HotspotButton extends HTMLElement {
	constructor() {
		super(),
			(this.button = this.querySelector('.hotspot-btn')),
			(this.content = this.querySelector('.hotspot__content')),
			(this.type = this.dataset.type),
			(this.openEvent = this.dataset.openEvent),
			(this.header = document.querySelector('.section-header')),
			(this.stickyHeader = document.querySelector('sticky-header')),
			(this.mobileOverlay = this.querySelector('.hotspot-overlay')),
			this.button.addEventListener('click', this.toggleModal.bind(this)),
			'hover' === this.openEvent &&
				(this.button.addEventListener('mouseover', this.openModal.bind(this)),
				this.button.addEventListener('mouseout', this.startCheckingMouseLeave.bind(this)),
				this.content.addEventListener('mouseover', this.stopCheckingMouseLeave.bind(this)),
				this.content.addEventListener('mouseout', this.startCheckingMouseLeave.bind(this))),
			this.mobileOverlay && this.mobileOverlay.addEventListener('click', this.closeModal.bind(this));
	}
	startCheckingMouseLeave() {
		(this.checkingMouseLeave = !0),
			setTimeout(() => {
				this.checkingMouseLeave && this.closeModal();
			}, 200);
	}
	stopCheckingMouseLeave() {
		this.checkingMouseLeave = !1;
	}
	toggleModal() {
		'true' === this.dataset.open ? this.closeModal() : this.openModal();
	}
	openModal() {
		let t = this.header.clientHeight;
		(this.header.classList.contains('shopify-section-header-hidden') || !this.stickyHeader) && (t = 0);
		this.content.getBoundingClientRect().top - t < 0 && (this.dataset.direction = 'bottom'),
			(this.dataset.open = 'true');
	}
	closeModal() {
		(this.dataset.open = 'false'),
			setTimeout(() => {
				this.dataset.direction = '';
			}, 100);
	}
	connectedCallback() {
		registerHotspotButton(this);
	}
	disconnectedCallback() {
		unregisterHotspotButton(this);
	}
}
customElements.define('hotspot-button', HotspotButton);

/*************************************************************
 * ParallaxHero
 ***********************************************************/
class ParallaxHero extends HTMLElement {
	constructor() {
		super(),
			(this.overlays = this.querySelectorAll('.parallax-hero__layer')),
			this.handleScroll(),
			window.addEventListener('scroll', () => requestAnimationFrame(this.handleScroll.bind(this)));
	}
	handleScroll(t) {
		var { top: e, left: i, height: s } = this.getBoundingClientRect();
		if (e > window.innerHeight || (e >= 0 ? (e = 0) : (e *= -1), e > s)) return;
		let n = e / s;
		this.overlays.forEach((t) => {
			let i = e * (parseInt(t.dataset.scrollY) / 100),
				s = parseInt(t.dataset.scrollX) * n,
				o = 100 + (parseInt(t.dataset.zoom) - 100) * n,
				r = 3.6 * parseInt(t.dataset.rotation) * n;
			t.style.transform = `translateY(${i}px) translateX(${s}%) scale(${o / 100}) rotate(${r}deg)`;
		});
	}
}

customElements.define('parallax-hero', ParallaxHero);

/*************************************************************
 * ContentTabs
 ***********************************************************/
class ContentTabs extends HTMLElement {
	constructor() {
		super(),
			(this.buttons = this.querySelectorAll('.content-tab-button')),
			(this.tabs = this.querySelectorAll('.content-tab')),
			(this.tabsContainer = this.querySelector('.content-tabs__tabs')),
			(this.activeButton = this.querySelector('.content-tab-button--active')),
			(this.activeTab = this.querySelector('.content-tab--active')),
			(this.isMovingAnimation = 'moving' === this.dataset.animation),
			this.isMovingAnimation &&
				((this.activeBg = this.querySelector('.content-tab-buttom__active-bg')),
				this.handleActiveBg(),
				(this.activeBg.style.transitionDuration = '0.4s')),
			this.setHeight(),
			this.buttons.forEach((t) => {
				t.addEventListener('click', this.handleClick.bind(this));
			}),
			window.addEventListener('resize', () => {
				this.setHeight(), this.isMovingAnimation && this.handleActiveBg();
			});
	}
	handleClick(t) {
		(this.activeButton = t.currentTarget),
			this.buttons.forEach((t) => {
				t.classList.remove('content-tab-button--active');
			}),
			this.activeButton.classList.add('content-tab-button--active'),
			this.tabs.forEach((t) => {
				t.classList.remove('content-tab--active'),
					t.dataset.index === this.activeButton.dataset.index && (this.activeTab = t);
			}),
			this.activeTab.classList.add('content-tab--active'),
			this.setHeight(),
			this.isMovingAnimation && this.handleActiveBg();
	}
	setHeight() {
		this.activeTab && (this.tabsContainer.style.height = this.activeTab.clientHeight + 'px');
	}
	handleActiveBg() {
		(this.activeBg.style.width = this.activeButton.getBoundingClientRect().width + 'px'),
			(this.activeBg.style.height = this.activeButton.getBoundingClientRect().height + 'px'),
			(this.activeBg.style.top = this.activeButton.offsetTop + 'px'),
			(this.activeBg.style.left = this.activeButton.offsetLeft + 'px');
	}
}

customElements.define('content-tabs', ContentTabs);

/*************************************************************
 * InstaStories
 ***********************************************************/
class InstaStories extends HTMLElement {
	constructor() {
		super(),
			(this.openButtons = this.querySelectorAll('.insta-story-open-btn')),
			(this.openButtonsOverflowContainer = this.querySelector('.insta-stories__open-buttons-container')),
			(this.openButtonsContainer = this.querySelector('.insta-stories__open-buttons')),
			(this.openBtnsPrev = this.querySelector('.insta-stories__open-btns-prev')),
			(this.openBtnsNext = this.querySelector('.insta-stories__open-btns-next')),
			(this.closeButtons = this.querySelectorAll('.insta-stories__close-button')),
			(this.modal = this.querySelector('.insta-stories__modal')),
			(this.modalOpen = !1),
			(this.slider = this.querySelector('.insta-stories__slider')),
			(this.stories = this.querySelectorAll('.insta-story')),
			(this.prevBtns = this.querySelectorAll('.insta-story__prev')),
			(this.nextBtns = this.querySelectorAll('.insta-story__next')),
			(this.slideBtns = this.querySelectorAll('.insta-story__slide-btn')),
			(this.activeIndex = 0),
			(this.activeStory = this.stories[this.activeIndex]),
			(this.lastIndex = parseInt(this.dataset.lastIndex)),
			(this.pauseResumeBtns = this.querySelectorAll('.insta-story__pause-resume-btn')),
			(this.isPaused = !1),
			(this.volumeBtns = this.querySelectorAll('.insta-story__volume-btn')),
			(this.isMuted = !0),
			this.initStories(),
			this.initButtonsSlider(),
			this.openButtons.forEach((t) => {
				t.addEventListener('click', this.openModal.bind(this));
			}),
			this.closeButtons.forEach((t) => {
				t.addEventListener('click', this.closeModal.bind(this));
			}),
			this.prevBtns.forEach((t) => {
				t.addEventListener('click', this.storyPrevBtnClick.bind(this));
			}),
			this.nextBtns.forEach((t) => {
				t.addEventListener('click', this.storyNextBtnClick.bind(this));
			}),
			this.slideBtns.forEach((t) => {
				t.addEventListener('click', this.slideBtnClick.bind(this));
			}),
			this.pauseResumeBtns.forEach((t) => {
				t.addEventListener('click', this.togglePauseResume.bind(this));
			}),
			this.volumeBtns.forEach((t) => {
				t.addEventListener('click', this.toggleIsMuted.bind(this));
			}),
			this.slider.addEventListener('touchstart', this.touchStartHandler.bind(this)),
			this.slider.addEventListener('touchend', this.touchEndHandler.bind(this)),
			document.addEventListener('keydown', (t) => {
				if (this.modalOpen)
					switch (t.key) {
						case 'Escape':
							this.closeModal();
							break;
						case 'ArrowLeft':
							this.storyPrevBtnClick();
							break;
						case 'ArrowRight':
							this.storyNextBtnClick();
					}
			}),
			Shopify.designMode &&
				(document.addEventListener('shopify:section:load', () => {
					this.initStories(), this.initButtonsSlider();
				}),
				document.addEventListener('shopify:section:reorder', () => {
					this.initStories(), this.initButtonsSlider();
				}));
	}
	autoplay() {
		let t = this.activeStory,
			e = parseInt(t.dataset.activeMediaIndex),
			i = t.querySelectorAll('.insta-story__media')[e],
			s = 1e3 * parseInt(i.getAttribute('data-duration'));
		this.updateProgressBars(e),
			(this.autoplayStartTime = Date.now()),
			(this.autoplayTimeout = setTimeout(() => {
				this.storyNextBtnClick();
			}, s));
	}
	storyPrevBtnClick() {
		let t = this.activeStory;
		'0' === t.dataset.activeMediaIndex
			? this.changeActiveStory(this.activeIndex - 1)
			: this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) - 1);
	}
	storyNextBtnClick() {
		let t = this.activeStory;
		t.dataset.activeMediaIndex === t.dataset.lastMediaIndex
			? this.changeActiveStory(this.activeIndex + 1)
			: this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) + 1);
	}
	slideBtnClick(t) {
		let e = parseInt(t.currentTarget.dataset.index);
		this.changeActiveStory(e);
	}
	changeActiveStory(t) {
		if ((clearTimeout(this.autoplayTimeout), t > this.lastIndex || t < 0)) return;
		let e = this.stories[this.activeIndex],
			i = parseInt(e.dataset.activeMediaIndex);
		if ('true' === e.dataset.played || i > 0) {
			let s = e.querySelectorAll('.insta-story__progress-item')[i];
			s &&
				(s.classList.remove('insta-story__progress-item--active'),
				t > this.activeIndex && s.classList.add('insta-story__progress-item--completed'));
		}
		let n = e.querySelectorAll('.insta-story__media')[i];
		if (n && 'video' === n.getAttribute('data-type')) {
			let o = n.querySelector('video');
			o && (o.pause(), this.isPaused || (o.currentTime = 0));
		}
		(this.activeIndex = t),
			(this.activeStory = this.stories[this.activeIndex]),
			this.stories.forEach((t) => {
				t.classList.remove('insta-story--active');
			}),
			this.activeStory.classList.add('insta-story--active'),
			(this.activeStory.dataset.played = 'true'),
			(this.slider.style.transform = `translateX(calc(var(--story-width) * ${-1 * this.activeIndex}))`);
		let r = parseInt(this.activeStory.dataset.activeMediaIndex, 10);
		this.changeActiveMedia(r), this.updateProgressBars(r);
	}
	changeActiveMedia(t) {
		if ((clearTimeout(this.autoplayTimeout), t < 0)) return;
		let e = this.activeStory,
			i = parseInt(e.dataset.lastMediaIndex);
		if (t > i) return;
		e.dataset.activeMediaIndex = t;
		let s = e.querySelectorAll('.insta-story__media');
		for (let n = 0; n < s.length; n++)
			if (n === t) {
				if (((s[n].style.display = 'block'), 'video' === s[n].getAttribute('data-type'))) {
					let o = s[n].querySelector('video');
					o && !this.isPaused && o.play();
				}
				e.querySelector('.insta-story__time-posted').innerHTML = s[n].dataset.timePosted;
			} else if (((s[n].style.display = ''), 'video' === s[n].getAttribute('data-type'))) {
				let r = s[n].querySelector('video');
				r && (r.pause(), this.isPaused || (r.currentTime = 0));
			}
		this.updateProgressBars(t), this.isPaused || this.autoplay();
		let a = e.querySelectorAll('.insta-story__prev'),
			l = e.querySelectorAll('.insta-story__next');
		a.forEach((e) => {
			0 === this.activeIndex && 0 === t ? e.setAttribute('disabled', '') : e.removeAttribute('disabled');
		}),
			l.forEach((e) => {
				this.activeIndex === this.lastIndex && t === i ? e.setAttribute('disabled', '') : e.removeAttribute('disabled');
			});
	}
	updateProgressBars(t) {
		let e = this.activeStory,
			i = e.querySelectorAll('.insta-story__progress-item');
		i.forEach((e, i) => {
			e.classList.remove('insta-story__progress-item--completed', 'insta-story__progress-item--active'),
				i < t
					? e.classList.add('insta-story__progress-item--completed')
					: i === t && e.classList.add('insta-story__progress-item--active');
		});
	}
	openModal(t) {
		window.scrollBy(0, -1),
			(this.modal.dataset.open = 'true'),
			(this.modalOpen = !0),
			document.body.classList.add('overflow-hidden'),
			this.changeActiveStory(parseInt(t.currentTarget.dataset.index));
	}
	closeModal(t) {
		this.querySelectorAll('video').forEach((t) => {
			t.pause();
		}),
			(this.modal.dataset.open = 'false'),
			(this.modalOpen = !1),
			document.body.classList.remove('overflow-hidden'),
			clearTimeout(this.autoplayTimeout);
	}
	initButtonsSlider() {
		if (this.openButtonsOverflowContainer.clientWidth > this.openButtonsContainer.clientWidth) return;
		let t = () => 'ontouchstart' in window || navigator.maxTouchPoints,
			e,
			i = 0,
			s = 0,
			n = (t) => {
				(this.openButtonsContainer.style.transform = `translateX(${t}px)`), (i = t);
			};
		this.openButtonsOverflowContainer.addEventListener('touchstart', (t) => {
			(this.isDragging = !0), (e = t.touches[0].clientX - s);
		}),
			this.openButtonsOverflowContainer.addEventListener('touchmove', (t) => {
				if (!this.isDragging) return;
				let i = t.touches[0].clientX,
					s = i - e;
				s < 0 &&
					Math.abs(s) <= this.openButtonsContainer.offsetWidth - this.openButtonsOverflowContainer.offsetWidth &&
					n(s);
			}),
			this.openButtonsOverflowContainer.addEventListener('touchend', () => {
				(this.isDragging = !1), (s = i);
			});
		let o = parseFloat(getComputedStyle(this.openButtons[0]).width),
			r = parseFloat(getComputedStyle(this.openButtonsContainer).columnGap),
			a = () => {
				let t = Math.floor(this.openButtonsOverflowContainer.clientWidth / (o + r));
				return (t - 1) * (o + r);
			},
			l = () => {
				(this.openBtnsPrev.style.display = this.openButtonsOverflowContainer.scrollLeft <= 0 ? 'none' : 'grid'),
					(this.openBtnsNext.style.display =
						this.openButtonsOverflowContainer.scrollLeft >
						this.openButtonsOverflowContainer.scrollWidth - this.openButtonsContainer.clientWidth
							? 'none'
							: 'grid');
			};
		this.openBtnsPrev.addEventListener('click', () => {
			this.openButtonsOverflowContainer.scrollBy({ left: -a(), behavior: 'smooth' }), setTimeout(l, 300);
		}),
			this.openBtnsNext.addEventListener('click', () => {
				this.openButtonsOverflowContainer.scrollBy({ left: a(), behavior: 'smooth' }), setTimeout(l, 300);
			}),
			l(),
			t() && ((this.openBtnsPrev.style.display = 'none'), (this.openBtnsNext.style.display = 'none')),
			window.addEventListener(
				'resize',
				debounce(() => {
					this.openButtonsOverflowContainer.clientWidth <= this.openButtonsContainer.clientWidth
						? t()
							? ((this.openBtnsPrev.style.display = 'none'), (this.openBtnsNext.style.display = 'none'))
							: l()
						: ((this.openBtnsPrev.style.display = 'none'), (this.openBtnsNext.style.display = 'none'));
				}, 250)
			);
	}
	initStories() {
		this.stories.forEach((t) => {
			let e = t.querySelectorAll('.insta-story__media');
			(t.dataset.lastMediaIndex = e.length - 1), (t.dataset.played = 'false');
			let i = t.querySelector('.insta-story__progress');
			for (let s = 0; s < e.length; s++) {
				let n = e[s].getAttribute('data-duration'),
					o = document.createElement('span');
				(o.className = 'insta-story__progress-item'), o.style.setProperty('--duration', `${n}s`);
				let r = document.createElement('span');
				(r.className = 'insta-story__progress-bar'), o.appendChild(r), i.appendChild(o);
			}
			let a = parseInt(t.dataset.activeMediaIndex);
			e[a] && (e[a].style.display = 'block');
		});
	}
	togglePauseResume(t) {
		let e = 'true' === t.currentTarget.getAttribute('data-paused');
		e ? this.resumeStory() : this.pauseStory(),
			this.pauseResumeBtns.forEach((t) => {
				t.setAttribute('data-paused', e ? 'false' : 'true');
			});
	}
	pauseStory() {
		this.isPaused = !0;
		let t =
				this.activeStory.querySelectorAll('.insta-story__media')[parseInt(this.activeStory.dataset.activeMediaIndex)],
			e = 1e3 * parseInt(t.getAttribute('data-duration'));
		if (
			((this.remainingTime = e - (Date.now() - this.autoplayStartTime)),
			clearTimeout(this.autoplayTimeout),
			'video' === t.getAttribute('data-type'))
		) {
			let i = t.querySelector('video');
			i && i.pause();
		}
		let s = this.querySelectorAll('.insta-story__progress-bar');
		s.forEach((t) => {
			t.style.animationPlayState = 'paused';
		});
	}
	resumeStory() {
		this.isPaused = !1;
		let t = this.querySelectorAll('.insta-story__progress-bar');
		t.forEach((t) => {
			t.style.animationPlayState = 'running';
		});
		let e =
			this.activeStory.querySelectorAll('.insta-story__media')[parseInt(this.activeStory.dataset.activeMediaIndex)];
		if ('video' === e.getAttribute('data-type')) {
			let i = e.querySelector('video');
			i && i.play();
		}
		(this.autoplayStartTime = Date.now()),
			(this.autoplayTimeout = setTimeout(() => {
				this.storyNextBtnClick();
			}, this.remainingTime));
	}
	toggleIsMuted(t) {
		t.currentTarget, (this.isMuted = !this.isMuted);
		let e = this.querySelectorAll('video');
		e.forEach((t) => {
			t.muted = this.isMuted;
		}),
			this.volumeBtns.forEach((t) => {
				this.isMuted ? t.setAttribute('data-muted', 'true') : t.setAttribute('data-muted', 'false');
			});
	}
	touchStartHandler(t) {
		this.touchStartX = t.touches[0].clientX;
	}
	touchEndHandler(t) {
		let e = t.changedTouches[0].clientX,
			i = e - this.touchStartX;
		!(50 > Math.abs(i)) &&
			(i < 0
				? this.activeIndex < this.lastIndex && this.changeActiveStory(this.activeIndex + 1)
				: this.activeIndex > 0 && this.changeActiveStory(this.activeIndex - 1));
	}
}
customElements.define('insta-stories', InstaStories);

